import { input, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { DynamicDialogRef } from '@common/ui/frontend-shared/dynamic-dialog';
import { UiInputTextareaComponent } from '@common/ui/frontend-shared/input-textarea';
import { LocalMessageHandlerService } from '@core/frontend-shared';
import { WebVTTParser } from 'webvtt-parser';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@common/ui/frontend-shared/dynamic-dialog";
import * as i3 from "@angular/forms";
function SubtitlesImportExportComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "ui-input-textarea", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("rows", 30)("ngModel", ctx_r0.webVtt());
  }
}
function SubtitlesImportExportComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "p");
    i0.ɵɵtext(2, "Bitte f\u00FCgen Sie die Untertitel im WebVTT-Format ein.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ui-input-textarea", 3);
    i0.ɵɵlistener("ngModelChange", function SubtitlesImportExportComponent_Conditional_1_Template_ui_input_textarea_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.importData.set($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("rows", 30)("ngModel", ctx_r0.importData());
  }
}
function SubtitlesImportExportComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "app-messages");
    i0.ɵɵelementStart(2, "button", 4);
    i0.ɵɵlistener("click", function SubtitlesImportExportComponent_Conditional_2_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.startImport());
    });
    i0.ɵɵelementEnd()();
  }
}
var ImportMode = /*#__PURE__*/function (ImportMode) {
  ImportMode[ImportMode["MERGE"] = 0] = "MERGE";
  ImportMode[ImportMode["REPLACE"] = 1] = "REPLACE";
  return ImportMode;
}(ImportMode || {});
export let SubtitlesImportExportComponent = /*#__PURE__*/(() => {
  class SubtitlesImportExportComponent {
    constructor(
    // private crudManager:CrudManagerService,
    messages, ref) {
      this.messages = messages;
      this.ref = ref;
      this.currentAbilities = input(null, ...(ngDevMode ? [{
        debugName: "currentAbilities"
      }] : /* istanbul ignore next */[]));
      this.mode = input(...(ngDevMode ? [undefined, {
        debugName: "mode"
      }] : /* istanbul ignore next */[]));
      this.webVtt = input(null, ...(ngDevMode ? [{
        debugName: "webVtt"
      }] : /* istanbul ignore next */[]));
      this.executing = signal(false, ...(ngDevMode ? [{
        debugName: "executing"
      }] : /* istanbul ignore next */[]));
      this.success = signal(null, ...(ngDevMode ? [{
        debugName: "success"
      }] : /* istanbul ignore next */[]));
      this.importData = signal(null, ...(ngDevMode ? [{
        debugName: "importData"
      }] : /* istanbul ignore next */[]));
    }
    startImport() {
      const importData = this.importData();
      this.messages.clear();
      if (!importData) {
        this.messages.createAndDisplay("Bitte Import-Daten einfügen").setSeverity("warn");
        return;
      }
      const validationResult = this.validateImportData(importData);
      if (validationResult !== true) {
        this.messages.createAndDisplay(validationResult.join('<br>\n')).setSeverity("warn");
        return;
      }
      this.executeImport(importData);
    }
    executeImport(importData) {
      this.ref.close({
        webVtt: importData
      });
    }
    validateImportData(data) {
      const parser = new WebVTTParser();
      const items = parser.parse(data, 'subtitles');
      if (items.errors.length) {
        const errorStr = items.errors.map(err => {
          return 'line ' + err.line + ': ' + err.message;
        }).join('<br/>\n');
        return ["Die eingegebenen Daten enthalten Fehler. Bitte geben Sie valide WebVTT-Untertitel an.", errorStr];
      }
      return true;
    }
    closeDialog() {
      this.ref.close(null);
    }
    static {
      this.ɵfac = function SubtitlesImportExportComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubtitlesImportExportComponent)(i0.ɵɵdirectiveInject(i1.LocalMessageHandlerService), i0.ɵɵdirectiveInject(i2.DynamicDialogRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: SubtitlesImportExportComponent,
        selectors: [["subtitles-import-export"]],
        inputs: {
          currentAbilities: [1, "currentAbilities"],
          mode: [1, "mode"],
          webVtt: [1, "webVtt"]
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 3,
        vars: 2,
        consts: [[1, "export-wrapper"], [1, "import-wrapper"], [3, "rows", "ngModel"], [3, "ngModelChange", "rows", "ngModel"], ["uiButton", "", "label", "Import ausf\u00FChren", 3, "click"]],
        template: function SubtitlesImportExportComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, SubtitlesImportExportComponent_Conditional_0_Template, 2, 2, "div", 0)(1, SubtitlesImportExportComponent_Conditional_1_Template, 4, 2, "div", 1);
            i0.ɵɵconditionalCreate(2, SubtitlesImportExportComponent_Conditional_2_Template, 3, 0, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.mode() === "export" ? 0 : 1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.mode() === "import" ? 2 : -1);
          }
        },
        dependencies: [FormsModule, i3.NgControlStatus, i3.NgModel, ReactiveFormsModule, UiInputTextareaComponent, UiButtonComponent, AppMessagesComponent],
        styles: ["ui-input-textarea[_ngcontent-%COMP%]{font-family:monospace}ui-input-selectbutton[_ngcontent-%COMP%]     .p-selectbutton{display:inline-block}.export-wrapper[_ngcontent-%COMP%], .import-wrapper[_ngcontent-%COMP%]{padding:15px;text-align:center}\n\n/*# sourceMappingURL=subtitles-import-export.component.ts-angular-inline--85.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return SubtitlesImportExportComponent;
})();